"use strict";

var _regeneratorRuntime = require("/opt/build/repo/node_modules/@babel/runtime/regenerator");

require("regenerator-runtime/runtime");

var _asyncToGenerator = require("/opt/build/repo/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _slicedToArray = require("/opt/build/repo/node_modules/@babel/runtime/helpers/slicedToArray");

var _classCallCheck = require("/opt/build/repo/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/opt/build/repo/node_modules/@babel/runtime/helpers/createClass");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

exports.__esModule = true;
exports.markmap = markmap;
exports.loadPlugins = loadPlugins;
exports.plugins = exports.Markmap = void 0;

var d3 = _interopRequireWildcard(require("d3"));

var _d3Flextree = require("d3-flextree");

var _util = require("./util");

var plugins = _interopRequireWildcard(require("./plugins"));

exports.plugins = plugins;

var _hook = require("./util/hook");

function linkWidth(nodeData) {
  var data = nodeData.data;
  return Math.max(6 - 2 * data.d, 1.5);
}

function adjustSpacing(tree, spacing) {
  (0, _util.walkTree)(tree, function (d, next) {
    d.ySizeInner = d.ySize - spacing;
    d.y += spacing;
    next();
  }, 'children');
}

var Markmap = /*#__PURE__*/function () {
  function Markmap(svg, opts) {
    var _this = this;

    _classCallCheck(this, Markmap);

    this.options = void 0;
    this.state = void 0;
    this.svg = void 0;
    this.styleNode = void 0;
    this.g = void 0;
    this.zoom = void 0;
    ['handleZoom', 'handleClick'].forEach(function (key) {
      _this[key] = _this[key].bind(_this);
    });
    this.svg = svg.datum ? svg : d3.select(svg);
    this.styleNode = this.svg.append('style');
    this.zoom = d3.zoom().on('zoom', this.handleZoom);
    this.options = Object.assign({
      duration: 500,
      nodeFont: '300 16px/20px sans-serif',
      nodeMinHeight: 16,
      spacingVertical: 5,
      spacingHorizontal: 80,
      autoFit: false,
      fitRatio: 0.95,
      color: function (colorFn) {
        return function (node) {
          return colorFn(node.p.i);
        };
      }(d3.scaleOrdinal(d3.schemeCategory10)),
      paddingX: 8
    }, opts);
    this.state = {
      id: this.options.id || (0, _util.getId)()
    };
    this.g = this.svg.append('g').attr('class', "".concat(this.state.id, "-g"));
    this.updateStyle();
    this.svg.call(this.zoom);
  }

  _createClass(Markmap, [{
    key: "getStyleContent",
    value: function getStyleContent() {
      var _this$options = this.options,
          style = _this$options.style,
          nodeFont = _this$options.nodeFont;
      var id = this.state.id;
      var extraStyle = typeof style === 'function' ? style(id) : '';
      var styleText = ".".concat(id, " a { color: #0097e6; }\n.").concat(id, " a:hover { color: #00a8ff; }\n.").concat(id, "-g > path { fill: none; }\n.").concat(id, "-fo > div { font: ").concat(nodeFont, "; white-space: nowrap; }\n.").concat(id, "-fo code { padding: .2em .4em; font-size: calc(1em - 2px); color: #555; background-color: #f0f0f0; border-radius: 2px; }\n.").concat(id, "-fo del { text-decoration: line-through; }\n.").concat(id, "-fo em { font-style: italic; }\n.").concat(id, "-fo strong { font-weight: 600; }\n.").concat(id, "-fo pre { margin: 0; }\n.").concat(id, "-fo pre[class*=language-] { padding: 0; }\n.").concat(id, "-g > g { cursor: pointer; }\n").concat(extraStyle, "\n");
      return styleText;
    }
  }, {
    key: "updateStyle",
    value: function updateStyle() {
      this.svg.attr('class', (0, _util.addClass)(this.svg.attr('class'), this.state.id));
      this.styleNode.text(this.getStyleContent());
    }
  }, {
    key: "handleZoom",
    value: function handleZoom() {
      var transform = d3.event.transform;
      this.g.attr('transform', transform);
    }
  }, {
    key: "handleClick",
    value: function handleClick(d) {
      var _data$p;

      var data = d.data;
      data.p = Object.assign(Object.assign({}, data.p), {}, {
        f: !((_data$p = data.p) == null ? void 0 : _data$p.f)
      });
      this.renderData(d.data);
    }
  }, {
    key: "initializeData",
    value: function initializeData(node) {
      var i = 0;
      var _this$options2 = this.options,
          nodeFont = _this$options2.nodeFont,
          color = _this$options2.color,
          nodeMinHeight = _this$options2.nodeMinHeight;
      var id = this.state.id;
      var container = document.createElement('div');
      var containerClass = "".concat(id, "-container");
      container.className = (0, _util.addClass)(container.className, "".concat(id, "-fo"), containerClass);
      var style = document.createElement('style');
      style.textContent = "\n".concat(this.getStyleContent(), "\n.").concat(containerClass, " {\n  position: absolute;\n  width: 0;\n  height: 0;\n  top: -100px;\n  left: -100px;\n  overflow: hidden;\n  font: ").concat(nodeFont, ";\n}\n.").concat(containerClass, " > div {\n  display: inline-block;\n}\n");
      document.body.append(style, container);
      (0, _util.walkTree)(node, function (item, next) {
        var _item$c;

        item.c = (_item$c = item.c) == null ? void 0 : _item$c.map(function (child) {
          return Object.assign({}, child);
        });
        i += 1;
        var el = document.createElement('div');
        el.innerHTML = item.v;
        container.append(el);
        item.p = Object.assign(Object.assign({}, item.p), {}, {
          // unique ID
          i: i,
          el: el
        });
        color(item); // preload colors

        next();
      });
      var nodes = (0, _util.arrayFrom)(container.childNodes);
      this.constructor.transformHtml.call(this, nodes);
      (0, _util.walkTree)(node, function (item, next, parent) {
        var _parent$p;

        var rect = item.p.el.getBoundingClientRect();
        item.v = item.p.el.innerHTML;
        item.p.s = [Math.ceil(rect.width), Math.max(Math.ceil(rect.height), nodeMinHeight)]; // TODO keep keys for unchanged objects
        // unique key, should be based on content

        item.p.k = "".concat((parent == null ? void 0 : (_parent$p = parent.p) == null ? void 0 : _parent$p.i) || '', ".").concat(item.p.i, ":").concat(item.v);
        next();
      });
      container.remove();
      style.remove();
    }
  }, {
    key: "setOptions",
    value: function setOptions(opts) {
      Object.assign(this.options, opts);
    }
  }, {
    key: "setData",
    value: function setData(data, opts) {
      if (!data) data = Object.assign({}, this.state.data);
      this.state.data = data;
      this.initializeData(data);
      if (opts) this.setOptions(opts);
      this.renderData();
    }
  }, {
    key: "renderData",
    value: function renderData(originData) {
      var _this2 = this;

      var _origin$data$p$x, _origin$data$p$y;

      if (!this.state.data) return;
      var _this$options3 = this.options,
          spacingHorizontal = _this$options3.spacingHorizontal,
          paddingX = _this$options3.paddingX,
          spacingVertical = _this$options3.spacingVertical,
          autoFit = _this$options3.autoFit,
          color = _this$options3.color;
      var id = this.state.id;
      var layout = (0, _d3Flextree.flextree)().children(function (d) {
        var _d$p;

        return !((_d$p = d.p) == null ? void 0 : _d$p.f) && d.c;
      }).nodeSize(function (d) {
        var _d$data$p$s = _slicedToArray(d.data.p.s, 2),
            width = _d$data$p$s[0],
            height = _d$data$p$s[1];

        return [height, width + (width ? paddingX * 2 : 0) + spacingHorizontal];
      }).spacing(function (a, b) {
        return a.parent === b.parent ? spacingVertical : spacingVertical * 2;
      });
      var tree = layout.hierarchy(this.state.data);
      layout(tree);
      adjustSpacing(tree, spacingHorizontal);
      var descendants = tree.descendants().reverse();
      var links = tree.links();
      var linkShape = d3.linkHorizontal();
      var minX = d3.min(descendants, function (d) {
        return d.x - d.xSize / 2;
      });
      var maxX = d3.max(descendants, function (d) {
        return d.x + d.xSize / 2;
      });
      var minY = d3.min(descendants, function (d) {
        return d.y;
      });
      var maxY = d3.max(descendants, function (d) {
        return d.y + d.ySizeInner;
      });
      Object.assign(this.state, {
        minX: minX,
        maxX: maxX,
        minY: minY,
        maxY: maxY
      });
      if (autoFit) this.fit();
      var origin = originData && descendants.find(function (item) {
        return item.data === originData;
      }) || tree;
      var x0 = (_origin$data$p$x = origin.data.p.x0) != null ? _origin$data$p$x : origin.x;
      var y0 = (_origin$data$p$y = origin.data.p.y0) != null ? _origin$data$p$y : origin.y; // Update the nodes

      var node = this.g.selectAll((0, _util.childSelector)('g')).data(descendants, function (d) {
        return d.data.p.k;
      });
      var nodeEnter = node.enter().append('g').attr('transform', function (d) {
        return "translate(".concat(y0 + origin.ySizeInner - d.ySizeInner, ",").concat(x0 + origin.xSize / 2 - d.xSize, ")");
      }).on('click', this.handleClick);
      var nodeExit = this.transition(node.exit());
      nodeExit.select('rect').attr('width', 0).attr('x', function (d) {
        return d.ySizeInner;
      });
      nodeExit.select('foreignObject').style('opacity', 0);
      nodeExit.attr('transform', function (d) {
        return "translate(".concat(origin.y + origin.ySizeInner - d.ySizeInner, ",").concat(origin.x + origin.xSize / 2 - d.xSize, ")");
      }).remove();
      var nodeMerge = node.merge(nodeEnter);
      this.transition(nodeMerge).attr('transform', function (d) {
        return "translate(".concat(d.y, ",").concat(d.x - d.xSize / 2, ")");
      });
      var rect = nodeMerge.selectAll((0, _util.childSelector)('rect')).data(function (d) {
        return [d];
      }, function (d) {
        return d.data.p.k;
      }).join(function (enter) {
        return enter.append('rect').attr('x', function (d) {
          return d.ySizeInner;
        }).attr('y', function (d) {
          return d.xSize - linkWidth(d) / 2;
        }).attr('width', 0).attr('height', linkWidth);
      }, function (update) {
        return update;
      }, function (exit) {
        return exit.remove();
      });
      this.transition(rect).attr('x', -1).attr('width', function (d) {
        return d.ySizeInner + 2;
      }).attr('fill', function (d) {
        return color(d.data);
      });
      var circle = nodeMerge.selectAll((0, _util.childSelector)('circle')).data(function (d) {
        return d.data.c ? [d] : [];
      }, function (d) {
        return d.data.p.k;
      }).join(function (enter) {
        return enter.append('circle').attr('stroke-width', '1.5').attr('cx', function (d) {
          return d.ySizeInner;
        }).attr('cy', function (d) {
          return d.xSize;
        }).attr('r', 0);
      }, function (update) {
        return update;
      }, function (exit) {
        return exit.remove();
      });
      this.transition(circle).attr('r', 6).attr('stroke', function (d) {
        return color(d.data);
      }).attr('fill', function (d) {
        var _d$data$p;

        return ((_d$data$p = d.data.p) == null ? void 0 : _d$data$p.f) ? color(d.data) : '#fff';
      });
      var foreignObject = nodeMerge.selectAll((0, _util.childSelector)('foreignObject')).data(function (d) {
        return [d];
      }, function (d) {
        return d.data.p.k;
      }).join(function (enter) {
        var fo = enter.append('foreignObject').attr('class', "".concat(id, "-fo")).attr('x', paddingX).attr('y', 0).style('opacity', 0).attr('height', function (d) {
          return d.xSize;
        });
        fo.append('xhtml:div').select(function (d) {
          var node = d.data.p.el.cloneNode(true);
          this.replaceWith(node);
          return node;
        }).attr('xmlns', 'http://www.w3.org/1999/xhtml');
        return fo;
      }, function (update) {
        return update;
      }, function (exit) {
        return exit.remove();
      }).attr('width', function (d) {
        return Math.max(0, d.ySizeInner - paddingX * 2);
      });
      this.transition(foreignObject).style('opacity', 1); // Update the links

      var path = this.g.selectAll((0, _util.childSelector)('path')).data(links, function (d) {
        return d.target.data.p.k;
      }).join(function (enter) {
        var source = [y0 + origin.ySizeInner, x0 + origin.xSize / 2];
        return enter.insert('path', 'g').attr('d', linkShape({
          source: source,
          target: source
        }));
      }, function (update) {
        return update;
      }, function (exit) {
        var source = [origin.y + origin.ySizeInner, origin.x + origin.xSize / 2];
        return _this2.transition(exit).attr('d', linkShape({
          source: source,
          target: source
        })).remove();
      });
      this.transition(path).attr('stroke', function (d) {
        return color(d.target.data);
      }).attr('stroke-width', function (d) {
        return linkWidth(d.target);
      }).attr('d', function (d) {
        var source = [d.source.y + d.source.ySizeInner, d.source.x + d.source.xSize / 2];
        var target = [d.target.y, d.target.x + d.target.xSize / 2];
        return linkShape({
          source: source,
          target: target
        });
      });
      descendants.forEach(function (d) {
        d.data.p.x0 = d.x;
        d.data.p.y0 = d.y;
      });
    }
  }, {
    key: "transition",
    value: function transition(sel) {
      var duration = this.options.duration;
      return sel.transition().duration(duration);
    }
  }, {
    key: "fit",
    value: function fit() {
      var svgNode = this.svg.node();

      var _svgNode$getBoundingC = svgNode.getBoundingClientRect(),
          offsetWidth = _svgNode$getBoundingC.width,
          offsetHeight = _svgNode$getBoundingC.height;

      var fitRatio = this.options.fitRatio;
      var _this$state = this.state,
          minX = _this$state.minX,
          maxX = _this$state.maxX,
          minY = _this$state.minY,
          maxY = _this$state.maxY;
      var naturalWidth = maxY - minY;
      var naturalHeight = maxX - minX;
      var scale = Math.min(offsetWidth / naturalWidth * fitRatio, offsetHeight / naturalHeight * fitRatio, 2);
      var initialZoom = d3.zoomIdentity.translate((offsetWidth - naturalWidth * scale) / 2 - minY * scale, (offsetHeight - naturalHeight * scale) / 2 - minX * scale).scale(scale);
      return this.transition(this.svg).call(this.zoom.transform, initialZoom).end().catch(_util.noop);
    }
  }, {
    key: "rescale",
    value: function rescale(scale) {
      var svgNode = this.svg.node();

      var _svgNode$getBoundingC2 = svgNode.getBoundingClientRect(),
          offsetWidth = _svgNode$getBoundingC2.width,
          offsetHeight = _svgNode$getBoundingC2.height;

      var halfWidth = offsetWidth / 2;
      var halfHeight = offsetHeight / 2;
      var transform = d3.zoomTransform(svgNode);
      var newTransform = transform.translate((halfWidth - transform.x) * (1 - scale) / transform.k, (halfHeight - transform.y) * (1 - scale) / transform.k).scale(scale);
      return this.transition(this.svg).call(this.zoom.transform, newTransform).end().catch(_util.noop);
    }
  }], [{
    key: "create",
    value: function create(svg, opts, data) {
      var mm = new Markmap(svg, opts);

      if (data) {
        mm.setData(data);
        mm.fit(); // always fit for the first render
      }

      return mm;
    }
  }]);

  return Markmap;
}();

exports.Markmap = Markmap;
Markmap.transformHtml = new _hook.Hook();

function markmap(svg, data, opts) {
  return Markmap.create(svg, opts, data);
}

function loadPlugins(_x, _x2) {
  return _loadPlugins.apply(this, arguments);
}

function _loadPlugins() {
  _loadPlugins = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(items, options) {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            items = items.map(function (item) {
              if (typeof item === 'string') {
                var name = item;
                item = plugins[name];

                if (!item) {
                  console.warn("[markmap] Unknown plugin: ".concat(name));
                }
              }

              return item;
            }).filter(Boolean);
            return _context.abrupt("return", (0, _util.initializePlugins)(Markmap, items, options));

          case 2:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _loadPlugins.apply(this, arguments);
}